import * as Schema from 'generated/graphql/schema';
import * as React from 'react';

import InputValidator from '@/components/validators-forms/input-validator';
import WrapRequiredFieldsDescriptionComponent from '@/views/common-components/wrap-required-fileds-description';
import { SensorSettingsState } from '@/views/dialogs/sensor-settings/sensor-settings-dialog';

import { TabPanelComponent, TabPropsType } from '.';

const isShown = (state: SensorSettingsState) => {
  // Do we need this check if it just goes && false?
  return state.peripheralType === Schema.PeripheralType.CAMERA && false;
};

export const TabProps: TabPropsType = {
  isShown,
  label: (t) => t('device:cameraSettings', { defaultValue: 'Camera' }),
};

export const TabPanel: TabPanelComponent = ({ handleChange, state, invalidFormMessage, classes, t }) => {
  if (!isShown(state)) {
    return null;
  }

  const onNameChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
    handleChange({}, { name: e.target.value });

  const onDescChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
    handleChange({}, { description: e.target.value });

  return (
    <div className={classes.tabPanel}>
      <InputValidator
        className={classes.textFields}
        containerClass={classes.containerClass}
        name="name"
        label={t(['device:sensorName'], { defaultValue: 'Sensor name' })}
        validators={['required', 'isString']}
        errorMessages={[
          t(['shared:fieldIsRequired'], { defaultValue: 'this field is required' }),
          t(['shared:mustBeString'], { defaultValue: 'must be a string' }),
        ]}
        value={state.name}
        onChange={onNameChange}
      />
      <br />
      <InputValidator
        className={classes.textFields}
        containerClass={classes.containerClass}
        name="description"
        label={<div>{t(['device:sensorDescription'], { defaultValue: 'Sensor description' })}</div>}
        validators={['isString']}
        errorMessages={[t(['shared:mustBeString'], { defaultValue: 'must be a string' })]}
        value={state.description}
        onChange={onDescChange}
      />
      {invalidFormMessage}

      <br />
      <WrapRequiredFieldsDescriptionComponent />
    </div>
  );
};
